// Components
import FeaturedListingCollection from './FeaturedListingCollection';

import type { ListingDetails } from '@/srcLegacy/types/listingDetails.type';

interface PortfolioPropertiesV2Props {
  portfolioListings: Array<ListingDetails>;
  onListingClick: () => void;
  screenWidthForDesktopSRPFilter?: 'sm' | 'md' | 'lg' | 'xl';
}

const PortfolioProperties = ({
  portfolioListings = [],
  onListingClick,
  screenWidthForDesktopSRPFilter,
}: PortfolioPropertiesV2Props) => {
  if (portfolioListings.length < 1) {
    return null;
  }

  return (
    <FeaturedListingCollection
      header="More from this provider"
      listings={portfolioListings}
      onListingClick={onListingClick}
      screenWidthForDesktopSRPFilter={screenWidthForDesktopSRPFilter}
      propertyCardTriggerLocation="portfolio_listings_module"
      triggerLocation={'home_details'}
      triggerObject={'home_details_component|more_from_provider'}
    />
  );
};

export default PortfolioProperties;
